<template>
  <!-- Modal -->
  <div class="modal fade" id="OrdersMoveReserveModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xxl">
      <div class="modal-content">
        <vue-element-loading :active="isSearching" spinner="bar-fade-scale" color="#333"/>
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">{{translations('order.reservation')}}</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div table-scroll>
            <table class="table table-striped table-align-middle">
              <thead>
                <tr>
                  <th>{{translations('order.order_date')}}</th>
                  <th>{{translations('order.order_number')}}</th>
                  <th>{{translations('order.bill_to')}}</th>
                  <th>{{translations('order.destination_name')}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="ordersInfo.division_type !== 'B'">
                  <td>
                    {{ ordersInfo.ordered_at ? $invoiceTools.formatDateAt(ordersInfo.ordered_at) : '-----------' }}
                  </td>
                  <td>{{ ordersInfo.order_number }}</td>
                  <td >
                    {{ ordersInfo.client && ordersInfo.client.name ? ordersInfo.client.name : '-----------' }}
                  </td>
                  <td>
                    {{ ordersInfo.destination_name ? ordersInfo.destination_name : '--------------' }}
                  </td>
                </tr>

                <tr v-else>
                  <td>
                    {{ ordersInfo.ordered_at ? $invoiceTools.formatDateAt(ordersInfo.ordered_at) : '-----------' }}
                  </td>
                  <td>{{ ordersInfo.order_number }}</td>
                  <td >
                    {{ ordersInfo.warehouse_address_from }}
                  </td>
                  <td>
                    {{ ordersInfo.warehouse_address }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="table-scroll">
          <table class="table table-striped table-align-middle">
            <thead>
              <tr>
                <th>{{translations('order.line_number')}}</th>
                <th>{{translations('order.jan_code')}}</th>
                <th>{{translations('order.model')}}</th>
                <th>{{translations('order.number_orders_received')}}</th>
                <th>{{translations('order.number_reserved')}}</th>
                <th>{{translations('order.client_order_number')}}</th>
                <th>{{translations('order.division')}}</th>
                <th>{{translations('order.number_of_reservations')}}</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(product, i) in ordersDetails">
              <tr :key="i">
                <td class="text-center">{{ i + 1 }}</td>
                <td>{{product.jan_code}}</td>
                <td>{{product.type_number}}</td>
                <td class="right">{{product.quantity.toLocaleString()}}</td>
                <td class="right">{{product.quantity_reserved.toLocaleString()}}</td>
                <td>{{product.client_order_number}}</td>
                <td>{{(Number(product.is_bad)) ? translations('order.bad') : Number(product.is_outlet) ? translations('order.outlet') : translations('order.good')}}</td>
                <td>
                  <input v-on:keyup="shippingQuantityKeyUp($event,product)" v-model="product.movingQuantity" class="form-control form-control-sm "  type="text" placeholder="0" min-value="0">
                </td>
              </tr>
              </template>
            </tbody>
          </table>
          </div>

        </div>
        <div class="modal-footer">
          <button ref="closeModal" type="button" class="btn btn-secondary" data-dismiss="modal">{{translations('common.close')}}</button>
          <button type="button" class="btn btn-primary" @click="moveToReserve">{{translations('common.update')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { mapState } from 'vuex'

export default {
  name: 'OrdersMoveReserveModal',
  components: {
    VueElementLoading
  },
  props: {
    reserve: Boolean,
    orderID: Number,
    ordersInfo: Object,
    ordersDetails: Array,
    allCheck: Boolean
  },
  data () {
    return {
      isSearching: false
    }
  },
  computed: {
    ...mapState(['currentLanguage'])
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    shippingQuantityKeyUp (event, product) {
      let { value } = event.target
      value = value.replace(/\D/g, '')
      if (value && value <= 0) value = 1
      event.target.value = value
      product.movingQuantity = Number(value)
      let remainQuantity = Number(product.quantity) - Number(product.quantity_reserved)

      if (product.movingQuantity > remainQuantity) {
        product.movingQuantity = remainQuantity
      }
    },

    async moveToReserve () {
      let successMessage = this.translations('order.notice_update_order_success')
      let errorMessage = this.translations('order.notice_update_order_fail')

      try {
        this.isSearching = true
        let paramUpdate = {
          orders_id: this.orderID,
          orders_detail: this.ordersDetails.map(product => ({
            ...product,
            movingQuantity: product.movingQuantity || 0 })),
          reserve: false,
          all_check: this.allCheck
        }

        let $data = await this.$http.post(this.$api_url.order_move_reserve, paramUpdate)
        if ($data.data.status === true) {
          this.$toastr.success(successMessage, this.translations('common.success'))
          this.isSearching = false
          setTimeout(() => {
            location.reload()
          }, '500')
        } else {
          this.isSearching = false
          this.$toastr.error($data.data.message, this.translations('common.error'))
        }
      } catch (error) {
        this.isSearching = false
        this.$toastr.error(errorMessage + this.translations('order.notice_check_error'), this.translations('common.error'))
      }
    }
  }
}
</script>

<style scoped>
.input-date {
  width: 160px;
}
</style>
